import { LoadablePaint, LoadableAfterPaint } from '@confluence/loadable';

import { ShareRestrictAndCopyButtonPlaceholder } from './v2/shareAndRestrictButton/ShareRestrictAndCopyButtonPlaceholder';

export const ShareAndRestrictButtonSSRLoader = LoadablePaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareRestrictAndCopyButton" */ './v2/shareAndRestrictButton/ShareRestrictAndCopyCoordinator'
			)
		).ShareRestrictAndCopyCoordinator,
});

export const ShareAndRestrictButtonLoader = LoadableAfterPaint<any>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ShareRestrictAndCopyButton" */ './v2/shareAndRestrictButton/ShareRestrictAndCopyCoordinator'
			)
		).ShareRestrictAndCopyCoordinator,
	loading: ShareRestrictAndCopyButtonPlaceholder,
});
